import { render, staticRenderFns } from "./ed-class-schedule-working-days-modal.component.vue?vue&type=template&id=2966a69c&scoped=true&"
import script from "./ed-class-schedule-working-days-modal.component.ts?vue&type=script&lang=ts&"
export * from "./ed-class-schedule-working-days-modal.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-class-schedule-working-days-modal.component.scss?vue&type=style&index=0&id=2966a69c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2966a69c",
  null
  
)

export default component.exports